module.exports = [{"id":1,"text":"Case"},{"id":2,"text":"Crate"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/Crates.json
// module id = 476
// module chunks = 4